import {Menu} from 'app/core/_model'
import {useUser} from 'app/hook/useUser'
import {Administrator, Cashier, Office, OfficeRestricted, SystemAdministrator} from 'consts/role'
const useMenu = () => {
  const {user} = useUser()
  const applicationMenu: Menu[] = [
    {
      title: 'Beranda',
      icon: '/media/icons/duotune/art/art002.svg',
      fontIcon: 'bi-app-indicator',
      to: '/dashboard',
      role: ['*'],
    },
    {
      title: 'Master',
      icon: '/media/icons/duotune/general/gen025.svg',
      fontIcon: 'bi-archive',
      to: '/master',
      role: ['*'],
      children: [
        {
          title: 'Bank',
          to: '/master/bank',
          hasBullet: true,
          role: [SystemAdministrator.value],
        },
        {
          title: 'Barang',
          to: '/master/barang',
          hasBullet: true,
          role: [SystemAdministrator.value, Office.value, OfficeRestricted.value],
        },
        {
          title: 'Kategori Barang',
          to: '/master/product-category',
          hasBullet: true,
          role: [SystemAdministrator.value],
        },
        {
          title: 'Product Article',
          to: '/master/product-article',
          hasBullet: true,
          role: [SystemAdministrator.value, Administrator.value],
        },
        {
          title: 'Customer',
          to: '/master/customer',
          hasBullet: true,
          role: [SystemAdministrator.value, Cashier.value, Office.value, OfficeRestricted.value],
        },
        {
          title: 'E-Wallet',
          to: '/master/e-wallet',
          hasBullet: true,
          role: [SystemAdministrator.value],
        },
        {
          title: 'Satuan',
          to: '/master/uom',
          hasBullet: true,
          role: [SystemAdministrator.value],
        },
        {
          title: 'Warna',
          to: '/master/colour',
          hasBullet: true,
          role: [SystemAdministrator.value],
        },
      ],
    },
    {
      title: 'Transaksi',
      icon: '/media/icons/duotune/general/gen025.svg',
      fontIcon: 'bi-archive',
      to: '/transaction',
      role: ['*'],
      children: [
        {
          title: 'Barang Masuk/Terima dari Cabang',
          to: '/transaction/product/incoming',
          hasBullet: true,
          role: [Office.value, OfficeRestricted.value],
        },
        {
          title: 'Barang Keluar/Retur ke Cabang/Extra',
          to: '/transaction/product/outgoing',
          hasBullet: true,
          role: [Cashier.value],
        },
        {
          title: 'Transaksi Penjualan',
          to: '/transaction/sales',
          hasBullet: true,
          role: [Cashier.value],
        },
      ],
    },
    {
      title: 'Report',
      icon: '/media/icons/duotune/general/gen025.svg',
      fontIcon: 'bi-archive',
      to: '/report',
      role: ['*'],
      children: [
        {
          title: 'Daftar Transaksi Barang Masuk',
          to: '/report/product/incoming',
          hasBullet: true,
          role: [SystemAdministrator.value, Office.value, OfficeRestricted.value],
        },
        {
          title: 'Daftar Transaksi Barang Keluar',
          to: '/report/product/outgoing',
          hasBullet: true,
          role: [SystemAdministrator.value, Cashier.value, Office.value, OfficeRestricted.value],
        },
        {
          title: 'Daftar Transaksi Penjualan',
          to: '/report/sales/outbond',
          hasBullet: true,
          role: [SystemAdministrator.value, Cashier.value, Office.value, OfficeRestricted.value],
        },
        {
          title: 'Laporan Barang Masuk Per Periode',
          to: '/report/product/transfer/incoming',
          hasBullet: true,
          role: [SystemAdministrator.value, Administrator.value, Cashier.value, Office.value, OfficeRestricted.value],
        },
        {
          title: 'Laporan Barang Keluar Per Periode',
          to: '/report/product/transfer/outgoing',
          hasBullet: true,
          role: [SystemAdministrator.value, Administrator.value, Cashier.value, Office.value, OfficeRestricted.value],
        },
        {
          title: 'Laporan Penjualan Per-Periode',
          to: '/report/sales/period',
          hasBullet: true,
          role: [SystemAdministrator.value, Administrator.value, Cashier.value, Office.value, OfficeRestricted.value],
        },
        {
          title: 'Penjualan Per Store',
          to: '/report/sales/per/store',
          hasBullet: true,
          role: [SystemAdministrator.value, Administrator.value, Office.value, OfficeRestricted.value],
        },
        {
          title: 'Penjualan All-Store',
          to: '/report/sales/all/store',
          hasBullet: true,
          role: [SystemAdministrator.value, OfficeRestricted.value],
        },
        {
          title: 'Rekap Penjualan 1 Tahun',
          to: '/report/sales/recap',
          hasBullet: true,
          role: [SystemAdministrator.value, Administrator.value, OfficeRestricted.value],
        },
        {
          title: 'Assortment Penjualan',
          to: '/report/sales/assortment',
          hasBullet: true,
          role: [SystemAdministrator.value, Administrator.value],
        },
        {
          title: 'Real Stock Store',
          to: '/report/product/real-stock',
          hasBullet: true,
          role: [SystemAdministrator.value, Office.value, OfficeRestricted.value, Cashier.value],
        },
        {
          title: 'Analisa Stock',
          to: '/report/stock/analyze',
          hasBullet: true,
          role: [SystemAdministrator.value, Administrator.value, (user?.is_restricted ?? false) === true ? '' : Office.value, (user?.is_restricted ?? false) === true ? '' : Cashier.value],
        },
        {
          title: 'Stock Per Store',
          to: '/report/product/stock/store',
          hasBullet: true,
          role: [SystemAdministrator.value, Administrator.value, (user?.is_restricted ?? false) === true ? '' : Office.value, (user?.is_restricted ?? false) === true ? '' : Cashier.value],
        },
        {
          title: 'Stock Per Barang',
          to: '/report/product/store/stock',
          hasBullet: true,
          role: [SystemAdministrator.value, Administrator.value],
        },
        {
          title: 'Persentase Golongan Artikel',
          to: '/report/sales/article/group',
          hasBullet: true,
          role: [SystemAdministrator.value, Administrator.value],
        },
        {
          title: 'Laporan Umur Barang',
          to: '/report/product/age',
          hasBullet: true,
          role: [SystemAdministrator.value, Administrator.value],
        },
      ],
    },
    {
      title: 'Management',
      divider: true,
      children: [],
      role: [SystemAdministrator.value],
    },
    {
      title: 'Wilayah',
      icon: '/media/icons/duotune/art/art002.svg',
      fontIcon: 'bi-app-indicator',
      to: '/settings/area',
      role: [SystemAdministrator.value],
    },
    {
      title: 'Store',
      icon: '/media/icons/duotune/art/art002.svg',
      fontIcon: 'bi-app-indicator',
      to: '/settings/store',
      role: [SystemAdministrator.value],
    },
    {
      title: 'User Management',
      icon: '/media/icons/duotune/art/art002.svg',
      fontIcon: 'bi-app-indicator',
      to: '/settings/user-management',
      role: [SystemAdministrator.value],
    },
  ]

  const noRoleMenu: Menu[] = [
    {
      title: 'Beranda',
      icon: '/media/icons/duotune/art/art002.svg',
      fontIcon: 'bi-app-indicator',
      to: '/dashboard',
    },
  ]

  return {noRoleMenu, applicationMenu}
}

export {useMenu}
